export const register = { id: 'step-register' }
export const company = { id: 'step-company' }
export const count = { id: 'step-count' }
export const password = { id: 'step-password' }
